import React, { useState, useEffect } from 'react';
import { useTranslate } from '../../../hooks/LanguageProvider';

interface SpeedAlarmProps {
  alarm: any; // Adapter le type en fonction de votre structure d'alarme
  onChange: (newMetrics: any) => void; // Fonction de rappel pour mettre à jour l'état du composant parent
}

const SpeedAlarm: React.FC<SpeedAlarmProps> = ({ alarm, onChange }) => {
  const [speed, setSpeed] = useState<string>("80");
  const { translate } = useTranslate();

  useEffect(() => {
    // console.log("alarm", alarm);
    if (alarm !== "") {
      setSpeed(alarm.max_speed);
    } else {
      setSpeed("80");
    }
  }, [alarm]);

 const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
   const value = event.target.value;
 
   // Autoriser l'effacement
   if (value === "") {
     setSpeed("");
     onChange({ ...alarm, type: "SpeedAlarm", max_speed: "" });
     return;
   }
 
   // Vérifier si c'est un nombre valide
   const numericValue = Number(value);
 
   // Bloquer si ce n'est pas un nombre ou hors limites
   if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 300) {
     setSpeed(value);
     onChange({ ...alarm, type: "SpeedAlarm", max_speed: numericValue });
   }
 };

 const setSpeedPreset = (value: number) => {
   setSpeed(String(value));
   onChange({ ...alarm, type: "SpeedAlarm", max_speed: value });
 };

 const handleSpeedPresetChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
   const value = Number(event.target.value);

   if (!isNaN(value)) {
     setSpeedPreset(value);
   }
 };
 
  return (
    <div
      className="col-md-7 col-sm-12 d-flex align-items-center flex-wrap"
      style={{ gap: "8px", marginTop: "2px" }}
    >
      <div className="input-group input-group-sm" style={{ width: "280px" }}>
        <span className="input-group-text">{translate("Speed")}</span>
        <input
          className="form-control"
          name="Speeding"
          value={speed}
          type="number"
          min={0}
          max={300}
          placeholder="Speed"
          onChange={handleInputChange}
        />
        <span className="input-group-text">Km/h</span>
      </div>
      <div className="input-group input-group-sm" style={{ width: "190px" }}>
        <select className="form-select" value={speed} onChange={handleSpeedPresetChange}>
          <option value="80">Lourd - 80 Km/h</option>
          <option value="90">Leger - 90 Km/h</option>
          <option value="110">Route - 110 Km/h</option>
          <option value="130">Autoroute - 130 Km/h</option>
        </select>
      </div>
    </div>
  );
};

export default SpeedAlarm;
